import { Box, Typography, Select, MenuItem, IconButton } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronLeft, faChevronRight } from "@fortawesome/pro-solid-svg-icons"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

const useStyles = makeStyles()(() => ({
    paginationContainer: {
        marginTop: "1rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
    },
    resultsPerPage: {
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
    },
    navigation: {
        display: "flex",
        alignItems: "center",
        gap: ".5rem",
    },
    navButton: {
        borderRadius: ".5rem",
        border: "1px solid #E2E8F0",
        width: "2.5rem",
        height: "2.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:disabled": {
            opacity: 0.5,
            cursor: "not-allowed",
        },
    },
}))

type MeetingListPaginationProps = {
    totalItems: number
    rowsPerPage: number
    currentPage: number
    setRowsPerPage: (rows: number) => void
    setCurrentPage: (page: number) => void
}

export function MeetingListPagination({
    totalItems,
    rowsPerPage,
    currentPage,
    setRowsPerPage,
    setCurrentPage,
}: MeetingListPaginationProps) {
    const { classes } = useStyles()
    const totalPages = Math.ceil(totalItems / rowsPerPage)
    const startItem = (currentPage - 1) * rowsPerPage + 1
    const endItem = Math.min(startItem + rowsPerPage - 1, totalItems)

    return (
        <Box className={classes.paginationContainer}>
            <Box className={classes.resultsPerPage}>
                <LocalizedStrict id="service-center-reports-dashboard-meeting-pagination">
                    <Typography variant="body2">Results per page</Typography>
                </LocalizedStrict>
                <Select value={rowsPerPage} onChange={(e) => setRowsPerPage(Number(e.target.value))} variant="standard">
                    {[10, 20, 50].map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </Select>
            </Box>

            <Box className={classes.navigation}>
                <Typography variant="body2">
                    {startItem}-{endItem} of {totalItems}
                </Typography>

                <IconButton
                    className={classes.navButton}
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    <FontAwesomeIcon size="xs" icon={faChevronLeft} />
                </IconButton>

                <IconButton
                    className={classes.navButton}
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    <FontAwesomeIcon size="xs" icon={faChevronRight} />
                </IconButton>
            </Box>
        </Box>
    )
}
